import axios from "http/customAxios";
import { v4 as uuidv4 } from "uuid";
import { DATE_SELECTION_TYPE, EXTRA_TYPE } from "../witadmin/Common/constants";
import { BodyPropertyARIType } from "./types";
import { add, differenceInDays, format } from "date-fns";
import { ENGINE_VERSION } from "./constants";
import { useHttpClient } from "../../lib/http";

export const fieldsRemoveAccomodations = [
  "establishment",
  "checkIn",
  "checkOut",
  "conditions",
  "promoCode",
];

export const fieldsRemoveAccomodationsRow = [
  "accommodations.adults",
  "accommodations.juniors",
  "accommodations.childrens",
  "accommodations.babies",
];

export const fieldsReCalcAccomodations = ["device", "country"];

export const getDataPropertyARI = (propertyARIRoute: string, body: BodyPropertyARIType) => {
  // TODO: replace with httpclient
  return axios.post(propertyARIRoute, body);
};

export const getPropertyData = async (propertyTicker: string, urlEngine: string) => {
  // TODO: replace with httpclient
  const url = `${urlEngine}/api/property/${propertyTicker}/es/propertyData`;
  const { data } = await axios.get(url);
  return {
    inventoryRelations: data[propertyTicker].inventoryRelations,
    establishmentName: { [propertyTicker]: data[propertyTicker].name },
  };
};

export const getPropertyConditions = async (
  propertyTicker: string,
  defaultLocale: string,
  urlAPI: string,
  locale: string
) => {
  // TODO: replace with httpclient
  const url = `${urlAPI}/api/backoffice/${propertyTicker}/conditions/`;
  const { data } = await axios.get(url);
  const newData = data.map((item: any) => {
    return { translations: item.translations, value: item.ticker, label: "" };
  });

  return newData;
};

export const sendEmail = (
  engineUrl: string,
  propertyTicker: string,
  body: {},
  locale: "string"
) => {
  // TODO: replace with httpclient
  const url = `${engineUrl}/api/quotation/${propertyTicker}/${locale}/priceEmail`;
  return axios.post(url, body);
};

export const generateTab = (userProfile: string, labelDesktop: string) => {
  const id = uuidv4();
  const newTab = {
    id,
    title: "Cotización",
    eventKey: id,
    establishment: "",
    checkIn: "",
    checkOut: "",
    condition: "",
    agent: userProfile,
    idClient: "",
    currency: "",
    promoCode: "",
    country: /*{ label: "España (ES)", value: "ES" }*/ "",
    lang: "",
    device: { value: "DESKTOP", label: labelDesktop },
    comment: "",
    accommodations: [
      {
        id: uuidv4(),
        adults: 0,
        juniors: 0,
        childrens: 0,
        babies: 0,
        units: 0,
        room: {},
      },
    ],
    extras: [
      {
        id: "",
      },
    ],
  };
  return newTab;
};

export const validateSearchData = (
  { checkIn, checkOut, accommodations, device, country }: any,
  indexRoom: any
) => {
  const validatePersons = () => {
    return seniors > 0 || adults > 0 || children > 0 || babies > 0;
  };
  const seniors = accommodations[indexRoom].seniors?.value || 0;
  const adults = accommodations[indexRoom].adults?.value || 0;
  const children = accommodations[indexRoom].children?.value || 0;
  const babies = accommodations[indexRoom].babies?.value || 0;
  return validatePersons() && checkIn && checkOut;
};

export const handleAddTab = (
  duplicate: boolean,
  setTabs: Function,
  tabs: any,
  actualTab: any,
  userProfile: any,
  labelDesktop: string
) => {
  if (duplicate) {
    const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
    setTabs([
      ...tabs,
      {
        ...tabs[indexTab > -1 ? indexTab : 0],
        id: uuidv4(),
        duplicado: indexTab > -1 ? indexTab : 0,
      },
    ]);
  } else {
    setTabs([...tabs, generateTab(userProfile?.email || "", labelDesktop)]);
  }
};

const getPromoCodes = (tabs: any, actTab: number) => {
  const currentTab = tabs[actTab];
  const hasPromoCodes = currentTab?.promoCodeTemp && currentTab?.promoCodeTemp !== null;
  return hasPromoCodes ? currentTab?.promoCodeTemp.split(",").map(it => it.trim()) : [];
};

export const validatePromoCode = async (
  tabs: any,
  actualTab: any,
  setTabs: any,
  urlEngine: string
) => {
  let actTab = tabs.findIndex((tab: any) => tab.id === actualTab);
  actTab = actTab > -1 ? actTab : 0;
  if (tabs?.[actTab]?.establishment?.value && tabs?.[actTab]?.checkIn && tabs?.[actTab]?.checkOut) {
    const promoCodes = getPromoCodes(tabs, actTab);
    const defaultMyPropertyARI = async (actTab: number) => {
      const dataBody = {
        start: tabs[actTab].checkIn,
        end: tabs[actTab].checkOut,
        seniors: 0,
        adults: 2,
        teenagers: 0,
        children: 0,
        babies: 0,
        deviceInfo: {
          deviceType: "DESKTOP",
        },
        locationInfo: {
          countryCode: "ES",
        },
        promoCodes,
        guestAges: null,
        propertyTickers: null,
        inventoryTickersLikeFilter: null,
        inventoryTickersEqualFilter: null,
        channel: null,
        ignoredConfiguration: false,
        totalAmount: null,
        reservationAmount: null,
      };
      const { data: dataPropertyARI } = await getDataPropertyARI(
        `${urlEngine}/api/property/${tabs[actTab].establishment.value}/es/propertyARI`,
        dataBody
      );
      return dataPropertyARI;
    };
    const res = await defaultMyPropertyARI(actTab);
    const newTabs = [...tabs];
    newTabs[actTab].invalidPromoCodes = [];
    const validPromoCode =
      res[tabs?.[actTab]?.establishment?.value || ""].validPromoCodes.length > 0 ? 1 : 0;
    newTabs[actTab].validPromoCode = validPromoCode;
    const newValuePromoCode = validPromoCode ? newTabs[actTab].promoCodeTemp : "";
    newTabs[actTab].promoCode = newValuePromoCode;
    newTabs[actTab].promoCodeTemp = newValuePromoCode;

    const newAccomodations = newTabs[actTab]?.accommodations?.map(
      ({ adults, babies, childrens, id, juniors }: any) => ({
        adults,
        babies,
        childrens,
        id,
        juniors,
        room: {},
        rooms: {},
        units: 0,
      })
    );

    newTabs[actTab].accommodations = newAccomodations;
    const validPromoCodes = res[tabs?.[actTab]?.establishment?.value || ""].validPromoCodes;
    const areAllPromoCodesValid = promoCodes.every(it => validPromoCodes.includes(it));
    if (!areAllPromoCodesValid) {
      const invalidPromoCodes = promoCodes.filter(
        it => !validPromoCodes.includes(it.toLowerCase())
      );
      newTabs[actTab].invalidPromoCodes = [
        ...newTabs[actTab].invalidPromoCodes,
        ...invalidPromoCodes,
      ];
    }
    setTabs(newTabs);
    return areAllPromoCodesValid;
  } else {
    return false;
  }
};

export const changeEstablishmentValue = async (
  tab: any,
  selectedOption: any,
  tabs: any,
  setTabs: any,
  urlAPI: string,
  backofficeLang: string,
  setModalPromoCode: any,
  setInventoryRelations: any,
  addEstablishmentName: any,
  dataConfiguration: any
) => {
  const { inventoryRelations, establishmentName } = await getPropertyData(
    selectedOption.value,
    urlAPI
  );
  setInventoryRelations(inventoryRelations);
  addEstablishmentName(establishmentName);
  const conditions = await getPropertyConditions(
    selectedOption.value,
    dataConfiguration.defaultLocale,
    urlAPI,
    backofficeLang
  );

  const newTabs = [...tabs];
  const indexTab = newTabs.findIndex(newTab => newTab.id === tab.id);
  const transforValues = (values: any) => {
    const newDataList = values.map((option: any) => {
      return { value: option, label: option };
    });
    return newDataList;
  };

  const availableLocales = transforValues(dataConfiguration?.availableLocales || []);
  const availableCurrencies = transforValues(dataConfiguration?.availableCurrencies || []);

  const getIndexLocale = (defaultLocal = "", oldValue = "") => {
    let indexLocale = -1;
    if (oldValue) {
      indexLocale = availableLocales.findIndex((locale: any) => locale.value === oldValue);
    }
    if (defaultLocal && indexLocale === -1) {
      indexLocale = availableLocales.findIndex((locale: any) => locale.value === defaultLocal);
    }
    return indexLocale;
  };

  const getIndexCurrency = (defaultCurrency: any) => {
    let indexCurrency = -1;
    indexCurrency = availableCurrencies.findIndex(
      (locale: any) => locale.value === defaultCurrency
    );
    return indexCurrency;
  };

  const newAccommodations = newTabs[indexTab]?.accommodations?.map(
    ({ adults, babies, childrens, id, juniors }: any) => ({
      adults: dataConfiguration?.maxAdults > 0 ? adults : 0,
      babies: dataConfiguration?.maxBabies > 0 ? babies : 0,
      childrens: dataConfiguration?.maxChildren > 0 ? childrens : 0,
      juniors: dataConfiguration?.maxTeenagers > 0 ? juniors : 0,
      id,
      room: {},
      rooms: {},
      units: 0,
    })
  );

  if (
    selectedOption.value &&
    tabs?.[indexTab]?.checkIn &&
    tabs?.[indexTab]?.checkOut &&
    tabs?.[indexTab]?.promoCode
  ) {
    const defaultMyPropertyARI = async (tab: any, ticker: string) => {
      const dataBody = {
        start: tab.checkIn,
        end: tab.checkOut,
        seniors: 0,
        adults: 2,
        teenagers: 0,
        children: 0,
        babies: 0,
        deviceInfo: {
          deviceType: "DESKTOP",
        },
        locationInfo: {
          countryCode: "ES",
        },
        promoCodes: tab?.promoCode ? tab?.promoCode.split(",").map(it => it.trim()) : [],
        guestAges: null,
        propertyTickers: null,
        inventoryTickersLikeFilter: null,
        inventoryTickersEqualFilter: null,
        channel: null,
        ignoredConfiguration: false,
        totalAmount: null,
        reservationAmount: null,
      };
      const { data: dataPropertyARI } = await getDataPropertyARI(
        `${urlAPI}/api/property/${ticker}/es/propertyARI`,
        dataBody
      );
      return dataPropertyARI;
    };

    const res = await defaultMyPropertyARI(tabs[indexTab], selectedOption.value);

    const validPromoCode = res[selectedOption.value].validPromoCodes.length > 0 ? 1 : 0;

    newTabs[indexTab].validPromoCode = validPromoCode;
    const newValuePromoCode = validPromoCode ? newTabs[indexTab].promoCodeTemp : "";
    newTabs[indexTab].promoCode = newValuePromoCode;
    newTabs[indexTab].promoCodeTemp = newValuePromoCode;
    setModalPromoCode(!validPromoCode);
  }
  const oldLang = newTabs[indexTab]?.lang?.value ? newTabs[indexTab]?.lang?.value : "";

  newTabs[indexTab] = {
    ...tab,
    establishment: selectedOption,
    lang: availableLocales[getIndexLocale(dataConfiguration.defaultLocale, oldLang)],
    currency:
      availableCurrencies[getIndexCurrency(dataConfiguration?.currencyExchange?.currencyBase)],
    configurations: {
      availableCurrencies,
      availableLocales,
      currencyExchange: dataConfiguration?.currencyExchange,
      maxAdults: dataConfiguration?.maxAdults,
      maxBabies: dataConfiguration?.maxBabies,
      maxChildren: dataConfiguration?.maxChildren,
      maxSeniors: dataConfiguration?.maxSeniors,
      maxTeenagers: dataConfiguration?.maxTeenagers,
      numberOfRoomsLeftLimit: dataConfiguration?.numberOfRoomsLeftLimit,
      occupantsMaxValues: dataConfiguration?.occupantsMaxValues,
      defaultLocale: dataConfiguration?.defaultLocale,
      addObligatoryExtrasRateToRoomSelection:
        dataConfiguration?.addObligatoryExtrasRateToRoomSelection,
      engineVersion: dataConfiguration?.engineVersion,
    },
    conditions,
    condition: {},
    accommodations: newAccommodations,
  };

  setTabs(newTabs);
};

export const changeConditions = (tab: any, selectedOption: any, tabs: any, setTabs: any) => {
  const newTabs = [...tabs];
  const indexTab = newTabs.findIndex(newTab => newTab.id === tab.id);
  const newAccommodations = newTabs[indexTab]?.accommodations?.map(
    ({ adults, babies, childrens, id, juniors }: any) => ({
      adults,
      babies,
      childrens,
      id,
      juniors,
      room: {},
      rooms: {},
      units: 0,
    })
  );
  newTabs[indexTab] = {
    ...tab,
    condition: selectedOption,
    accommodations: newAccommodations,
  };
  setTabs(newTabs);
};

export const changeMealPlanInventory = (
  indexInventory: any,
  mealPlan: any,
  dataInventories: any,
  setDataInventories: any
) => {
  const newDataInventories = [...dataInventories];
  if (newDataInventories[indexInventory]) {
    newDataInventories[indexInventory].mealPlan = mealPlan;
    newDataInventories[indexInventory].mealplan = mealPlan?.value;
    newDataInventories[indexInventory].services = mealPlan?.services;
  }
  setDataInventories([...newDataInventories]);
};

export const changeRoomInventory = (
  indexInventory: any,
  rooms: any,
  dataInventories: any,
  setDataInventories: any,
  tabs: any,
  setTabs: any,
  actualTab: any,
  actualRoom: any
) => {
  let newIndexInventory = indexInventory;
  if (indexInventory?.ticker) {
    newIndexInventory = dataInventories.findIndex(
      (dataInventory: any) => dataInventory.ticker === indexInventory.ticker
    );
  }
  const newDataInventories = [...dataInventories];
  newDataInventories[newIndexInventory].rooms = rooms;

  const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);

  tabs[indexTab].accommodations[actualRoom].rooms = rooms;
  const newObligatoryExtrasValue = newDataInventories[
    newIndexInventory
  ].mealPlan.dataExtrasObligatory.reduce((acc: any, extra: any) => {
    const list: any = [];
    const startReservation = new Date(tabs[indexTab].checkIn);
    const endReservation = new Date(tabs[indexTab].checkOut);
    const diffDates = differenceInDays(endReservation, startReservation);
    for (let index = 0; index < diffDates; index++) {
      list.push(format(add(startReservation, { days: index }), "EEEEEE dd MMM"));
    }

    const objExtra = {
      ...extra,
      list,
      ariValue: {
        totalRate: extra?.originalRate,
      },
    };

    acc += extra?.originalRate ? getExtraValueByType(objExtra, tabs[indexTab], actualRoom) : 0;

    return acc;
  }, 0);

  newDataInventories[
    newIndexInventory
  ].mealPlan.prices.obligatoryExtrasValue = newObligatoryExtrasValue;
  setDataInventories([...newDataInventories]);
};

export const handleDeleteConfirm = (
  idTab: any,
  tabs: any,
  setActualTab: any,
  setTabs: any,
  setModalConfirmation: any
) => {
  if (tabs.length > 1) {
    const indexTab: number = tabs.findIndex((tab: any) => tab.id === idTab);
    if (indexTab > -1) {
      setActualTab(indexTab === 0 ? tabs[1].id : tabs[0].id);
      tabs.splice(indexTab, 1);
      setTabs([...tabs]);
      setModalConfirmation(false);
    } else {
      console.info(`Warning. Not finded ${idTab}`);
    }
  } else {
    console.info(`Warning. ${idTab} can't delete. Not finded on all tabs`);
  }
};

interface ValuesByNumber {
  value: number;
  label: string;
}

export const getValuesByNumber = (
  quantity: number,
  label: string = "",
  initialIndex = 0,
  plusQuiantity = { value: 0 }
) => {
  let values: ValuesByNumber[] = [];
  const finalQuantity = quantity + plusQuiantity.value;
  for (let index = initialIndex; index <= finalQuantity; index++) {
    values.push({ value: index, label: `${index} ${label}` });
  }
  return values;
};

export const getDataBodyPropertyAri = (tab: any, accommodation: any, device: any) => {
  return {
    start: tab.checkIn,
    end: tab.checkOut,
    seniors: accommodation?.seniors?.value || 0,
    adults: accommodation?.adults?.value || 0,
    teenagers: accommodation?.juniors?.value || 0,
    children: accommodation?.childrens?.value || 0,
    babies: accommodation?.babies?.value || 0,
    deviceInfo: {
      deviceType: "DESKTOP",
    },
    locationInfo: {
      countryCode: "ES",
    },
    promoCodes: tab?.promoCode ? tab?.promoCode.split(",").map(it => it.trim()) : [],
    guestAges: null,
    propertyTickers: null,
    inventoryTickersLikeFilter: null,
    inventoryTickersEqualFilter: null,
    channel: null,
    ignoredConfiguration: false,
    totalAmount: null,
    reservationAmount: null,
  };
};

export const getEmailBody = (
  tab: any,
  firstEmail: string,
  secondtEmail: string,
  emailSubject: string
) => {
  const startReservation = new Date(tab.checkIn);
  const endReservation = new Date(tab.checkOut);
  const diffDates = differenceInDays(endReservation, startReservation);

  const stayDate: any = [];
  for (let index = 0; index < diffDates; index++) {
    stayDate.push(format(add(startReservation, { days: index }), "y-MM-dd"));
  }

  const cart = tab.accommodations.map((acc: any) => {
    const services = acc.extraSelected
      .map((extra: any) => {
        if (extra.obligatory) {
          return { ...transformExtra({ extra, stayDate }), ticker: extra.ticker };
        } else if (
          extra.open ||
          (extra.type === "UNIT" &&
            extra.dateSelectionType === "NONE" &&
            extra.list?.[0]?.value?.value) ||
          (extra.type === "UNIT" &&
            extra.dateSelectionType === "ALL" &&
            extra.list?.[0]?.value?.value)
        ) {
          return {
            ...transformExtra({ extra, stayDate, numberRoom: acc.rooms.value }),
            ticker: extra.ticker,
          };
        }
      })
      .filter((extra: any) => extra);
    return {
      numberOfUnits: acc.rooms.value,
      ticker: `${acc.accommodation}_${acc.configuration}_${acc.mealplan}_${acc.condition}`,
      services,
    };
  });

  return {
    agent: tab.agent,
    customerId: tab.idClient,
    checkIn: tab.checkIn,
    checkOut: tab.checkOut,
    country: "ES",
    currency: tab.currency.value,
    promoCodes: tab.promoCode ? tab.promoCode.split(",").map(it => it.trim()) : [],
    cart: cart,
    deviceInfo: {
      deviceType: "DESKTOP",
    },
    comments: tab.comment,
    email1: firstEmail,
    email2: secondtEmail,
    subject: emailSubject,
  };
};

export const changeValue = async ({
  calcAccomodation,
  setCalcAccomodation,
  tabs,
  setTabs,
  tab,
  key,
  value,
  indexRoom = 0,
}: any) => {
  let firstKey = "";
  let secondKey = "";
  let newTab: any;

  if (key.includes(".")) {
    const x = key.split(".");
    firstKey = x[0];
    secondKey = x[1];

    if (fieldsRemoveAccomodations.includes(key)) {
      const newAccomodations = tab?.accommodations?.map(
        ({ adults, babies, childrens, id, juniors }: any) => ({
          adults,
          babies,
          childrens,
          id,
          juniors,
          room: {},
          rooms: {},
          units: 0,
        })
      );
      newTab = {
        ...tab,
        accommodations: newAccomodations,
      };
    } else if (fieldsRemoveAccomodationsRow.includes(key)) {
      const indexTab = tabs.findIndex((newTab: any) => newTab.id === tab.id);
      newTab = { ...tab };
      newTab.accommodations[indexRoom] = {
        ...tabs[indexTab].accommodations[indexRoom],
        room: {},
        rooms: {},
        units: 0,
      };
    } else if (fieldsReCalcAccomodations.includes(key)) {
      const indexTab = tabs.findIndex((newTab: any) => newTab.id === tab.id);
      newTab = {
        ...tab,
        [key]: value,
      };
      let newTabs = [...tabs];
      newTabs[indexTab] = newTab;
      setTabs(newTabs);
      setCalcAccomodation(!calcAccomodation);
    } else {
      newTab = {
        ...tab,
        [key]: value,
      };
    }

    newTab[firstKey][indexRoom][secondKey] = value;
  } else {
    if (fieldsRemoveAccomodations.includes(key)) {
      const newAccomodations = tab?.accommodations?.map(
        ({ adults, babies, childrens, id, juniors }: any) => ({
          adults,
          babies,
          childrens,
          id,
          juniors,
          room: {},
          rooms: {},
          units: 0,
        })
      );

      newTab = {
        ...tab,
        accommodations: newAccomodations,
        [key]: value,
      };
    } else if (fieldsReCalcAccomodations.includes(key)) {
      const indexTab = tabs.findIndex((newTab: any) => newTab.id === tab.id);

      newTab = {
        ...tab,
        [key]: value,
      };

      let newTabs = [...tabs];
      newTabs[indexTab] = newTab;

      setTabs(newTabs);

      setCalcAccomodation(!calcAccomodation);
    } else {
      newTab = {
        ...tab,
        [key]: value,
      };
    }
  }

  if (!fieldsReCalcAccomodations.includes(key)) {
    const newTabs = [...tabs];
    const indexTab = newTabs.findIndex(newTab => newTab.id === tab.id);
    newTabs[indexTab] = newTab;
    setTabs(newTabs);
  }
};

const calcObligatoryExtraValue = ({
  dataAri,
  joinAccomodations,
  tabs,
  indexTab,
  actualRoom,
}: any) => {
  const dataExtrasObligatory: any[] = [];
  const obligatoryExtrasValue = dataAri?.inventories?.[joinAccomodations]?.services.reduce(
    (acc: any, idExtra: any) => {
      if (dataAri.services?.[idExtra]?.obligatory) {
        const list: any = [];
        const startReservation = new Date(tabs[indexTab].checkIn);
        const endReservation = new Date(tabs[indexTab].checkOut);
        const diffDates = differenceInDays(endReservation, startReservation);
        for (let index = 0; index < diffDates; index++) {
          list.push(format(add(startReservation, { days: index }), "EEEEEE dd MMM"));
        }

        const objExtra = {
          ...dataAri.arivalues?.[idExtra],
          ...dataAri.services?.[idExtra],
          list,
          ariValue: {
            totalRate: dataAri.arivalues?.[idExtra]?.originalRate,
          },
        };

        if (
          dataExtrasObligatory.findIndex(
            (dataExtra: any) => dataExtra.ticker === objExtra.ticker
          ) === -1
        ) {
          dataExtrasObligatory.push(objExtra);
        }

        acc += dataAri.arivalues?.[idExtra]?.originalRate
          ? getExtraValueByType(objExtra, tabs[indexTab], actualRoom)
          : 0;
      }
      return acc;
    },
    0
  );
  return {
    obligatoryExtrasValue,
    dataExtrasObligatory,
  };
};

function calculateMealPlanOccupations(occupationsStr: string) {
  const occupationsObj = {
    babies: {},
    childrens: {},
    adults: {},
    juniors: {},
  };
  const occupationsRaw = occupationsStr
    .match(/.{1,2}/g)
    ?.map((str: string) => str.match(/.{1,1}/g) || [""]);
  if (occupationsRaw) {
    occupationsRaw.forEach((occ: string[]) => {
      const obj = {
        value: Number(occ[0]),
        label: occ[0],
      };
      switch (occ[1]) {
        case "a":
          occupationsObj.adults = obj;
          break;
        case "j":
          occupationsObj.juniors = obj;
          break;
        case "n":
          occupationsObj.childrens = obj;
          break;
        case "b":
          occupationsObj.babies = obj;
          break;
      }
    });
    return occupationsObj;
  }
}

export const functionGetNewValuesAccomodation = async (
  tabs: any,
  setTabs: any,
  actualTab: any,
  validateInventory: any,
  myPropertyARI: any,
  actualRoom: number
) => {
  const newTabs = [...tabs];
  const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
  if (indexTab === -1) {
    return;
  }

  const tab = tabs[indexTab];

  const getAccommodationsByPropertyAriOfNewValues = (valuesDataPropertyAri: any) => {
    if (!valuesDataPropertyAri) {
      return [];
    }

    const dataAri: {
      inventories: any[];
      accommodations: any;
      mealplans: any;
      arivalues: any;
      conditions: any;
      services: any;
    } = valuesDataPropertyAri;
    let dataInventories: any = [];
    let dataInventoriesNotApplyCondition: any = [];

    for (const [key, value] of Object.entries(dataAri.inventories)) {
      if (value?.condition !== tabs[indexTab]?.condition.value) {
        dataInventoriesNotApplyCondition[key] = {
          value,
        };
      } else {
        const nameMealPlan = dataAri.mealplans?.[value.mealplan]?.name;
        const nameCondition = dataAri.conditions[value.condition].name;
        const nameAccommodation = dataAri.accommodations?.[value.accommodation]?.name;
        const allMealplans = Object.values({ ...dataAri.mealplans }).map((mealplan: any) => {
          const joinAccomodations: any = `${value.ticker}`;

          const { obligatoryExtrasValue, dataExtrasObligatory } = calcObligatoryExtraValue({
            dataAri,
            joinAccomodations,
            tabs,
            indexTab,
            actualRoom,
          });

          const newPrices = validateInventory(
            dataAri?.arivalues?.[joinAccomodations],
            value.ticker,
            tabs[indexTab].accommodations
          );
          return {
            value: mealplan.ticker,
            label: mealplan.name,
            prices: { ...newPrices, obligatoryExtrasValue },
            extraPrice: 0,
            dataExtrasObligatory,
          };
        });
        const indexInventory = dataInventories.findIndex(
          (inventory: any) => inventory.accommodation === value.accommodation
        );
        const mealPlanIndexToAdd = allMealplans.findIndex(
          (mealPlan: any) => mealPlan.value === value.mealplan
        );

        if (indexInventory > -1) {
          let newInventory = { ...dataInventories[indexInventory] };
          newInventory.mealplans.push({ ...allMealplans[mealPlanIndexToAdd] });
        } else {
          let rooms = { value: 1, label: "1 Habitación" };
          tabs[indexTab].accommodations.forEach((accommodation: any) => {
            if (accommodation.ticker === value.ticker) {
              rooms = accommodation.rooms;
            }
          });
          dataInventories.push({
            ...value,
            rooms,
            nameAccommodation,
            nameMealPlan,
            nameCondition,
            mealPlan: { ...allMealplans[mealPlanIndexToAdd] },
            mealplans: [{ ...allMealplans[mealPlanIndexToAdd] }],
          });
        }
      }
    }

    let availableData: any[] = [];
    let restrictedData: any[] = [];
    let soldOutData: any[] = [];
    dataInventories.forEach((inventory: any) => {
      if (inventory.mealPlan.prices.lastStatus.code === "AVAILABLE") {
        availableData.push(inventory);
      } else if (inventory.mealPlan.prices.restricted) {
        restrictedData.push(inventory);
      } else if (inventory.mealPlan.prices.availability <= 0) {
        soldOutData.push(inventory);
      }
    });
    return [...availableData, ...restrictedData, ...soldOutData];
  };

  const waitFor = async () => {
    for await (const accommodation of tab.accommodations) {
      const indexRoom = tab.accommodations.findIndex(
        (accom: any) => accom.accommodation === accommodation.accommodation
      );
      const resMyPropertAri = await myPropertyARI(indexRoom);
      const dataInventories = getAccommodationsByPropertyAriOfNewValues(
        resMyPropertAri[tab?.establishment?.value]
      );

      const newInventoryIndex = dataInventories.findIndex(
        (inventory: any) => inventory.accommodation === accommodation.accommodation
      );
      const newInventorySelected: any = dataInventories[newInventoryIndex];
      newTabs[indexTab].accommodations[indexRoom] = {
        ...newTabs[indexTab].accommodations[indexRoom],
        ...newInventorySelected,
      };
    }
    return newTabs;
  };

  const res = await waitFor();

  setTabs(res);
};

export const handleConfirmExtra = (
  tabs: any,
  actualTab: any,
  actualRoom: any,
  dataExtrasRoom: any,
  setTabs: any,
  setModalExtras: any
) => {
  const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
  const tab = tabs[indexTab];
  let newTabs = [...tabs];
  let newTab = { ...tab };
  if (newTab?.accommodations?.[actualRoom]) {
    newTab.accommodations[actualRoom].extraSelected = dataExtrasRoom;
    let total = 0;
    dataExtrasRoom.forEach((element: any) => {
      total += getExtraValueByType(element, newTab, actualRoom);
    });

    newTab.accommodations[actualRoom].extraValue = total;
    newTabs[indexTab] = newTab;
    setTabs([...newTabs]);
    setModalExtras(false);
  }
};

const getPersons = (actualRoom: any, appliesToGuests: any) => {
  let persons = 0;

  if (appliesToGuests.includes("ADULT") || appliesToGuests.includes("SENIOR")) {
    persons += actualRoom?.adults?.value || 0;
  }
  if (appliesToGuests.includes("BABY")) {
    persons += actualRoom?.babies?.value || 0;
  }
  if (appliesToGuests.includes("CHILD")) {
    persons += actualRoom?.childrens?.value || 0;
  }
  if (appliesToGuests.includes("TEENAGER")) {
    persons += actualRoom?.juniors?.value || 0;
  }
  return persons * (actualRoom?.rooms?.value || 1);
};

const getValueByListDay = (listDays: any) => {
  let total = 0;
  if (Array.isArray(listDays)) {
    listDays.forEach(element => {
      total += element?.value?.value ? element?.value?.value : element?.value;
    });
  } else {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    for (const [_key, value] of Object.entries(listDays)) {
      total += Number(value);
    }
  }
  return total;
};

export const getExtraValueByType = (element: any, newTab: any, actualRoom: number) => {
  let total = 0;

  if (
    element.type === EXTRA_TYPE.ROOM &&
    element.dateSelectionType === DATE_SELECTION_TYPE.SPECIFIC &&
    (element.open || element.obligatory)
  ) {
    total +=
      ((newTab.accommodations[actualRoom]?.rooms?.value || 1) *
        getValueByListDay(element.totalRatePerDay ? element.totalRatePerDay : element.list) || 0) *
      element.ariValue.totalRate;
  }
  if (
    element.type === EXTRA_TYPE.ROOM &&
    element.dateSelectionType === DATE_SELECTION_TYPE.NONE &&
    (element.open || element.obligatory)
  ) {
    total += (newTab.accommodations[actualRoom]?.rooms?.value || 1) * element.ariValue.totalRate;
  }
  if (
    element.type === EXTRA_TYPE.ROOM &&
    element.dateSelectionType === DATE_SELECTION_TYPE.ALL &&
    (element.open || element.obligatory)
  ) {
    const startReservation = new Date(newTab.checkIn);
    const endReservation = new Date(newTab.checkOut);
    const diffDates = differenceInDays(endReservation, startReservation);
    total +=
      (newTab.accommodations[actualRoom]?.rooms?.value || 1) *
      (element?.list?.length || diffDates) *
      element.ariValue.totalRate;
  }
  if (
    element.type === EXTRA_TYPE.PERSON &&
    element.dateSelectionType === DATE_SELECTION_TYPE.NONE &&
    (element.open || element.obligatory)
  ) {
    total +=
      getPersons(newTab.accommodations[actualRoom], element.appliesToGuests) *
      element.ariValue.totalRate;
  }
  if (
    element.type === EXTRA_TYPE.PERSON &&
    element.dateSelectionType === DATE_SELECTION_TYPE.SPECIFIC &&
    (element.open || element.obligatory)
  ) {
    total +=
      getPersons(newTab.accommodations[actualRoom], element.appliesToGuests) *
      (element?.list?.length || 0) *
      //(newTab.accommodations[actualRoom]?.rooms?.value || 1) *
      element.ariValue.totalRate;
  }
  if (
    element.type === EXTRA_TYPE.PERSON &&
    element.dateSelectionType === DATE_SELECTION_TYPE.ALL &&
    (element.open || element.obligatory)
  ) {
    const startReservation = new Date(newTab.checkIn);
    const endReservation = new Date(newTab.checkOut);
    const diffDates = differenceInDays(endReservation, startReservation);
    total +=
      getPersons(newTab.accommodations[actualRoom], element.appliesToGuests) *
      diffDates *
      element.ariValue.totalRate;
  }
  if (element.type === EXTRA_TYPE.UNIT && element.dateSelectionType === DATE_SELECTION_TYPE.NONE) {
    total +=
      (element?.list?.[0]?.value?.value || 0) *
      element.ariValue.totalRate *
      (newTab.accommodations[actualRoom]?.rooms?.value || 1);
  }
  if (
    element.type === EXTRA_TYPE.UNIT &&
    element.dateSelectionType === DATE_SELECTION_TYPE.SPECIFIC &&
    (element.open || element.obligatory)
  ) {
    let tempV = 0;
    element?.list.forEach((element: any) => {
      tempV += element?.value?.value || 0;
    });
    total +=
      tempV * (newTab.accommodations[actualRoom]?.rooms?.value || 1) * element.ariValue.totalRate;
  }
  if (element.type === EXTRA_TYPE.UNIT && element.dateSelectionType === DATE_SELECTION_TYPE.ALL) {
    const startReservation = new Date(newTab.checkIn);
    const endReservation = new Date(newTab.checkOut);
    const diffDates = differenceInDays(endReservation, startReservation);
    let finalValue = 0;
    if (element?.list?.[0]?.value?.value || element?.list?.[0]?.value?.value === 0) {
      finalValue = element?.list?.[0]?.value?.value;
    } else {
      finalValue = element?.list?.[0]?.value || 0;
    }
    total +=
      finalValue *
      diffDates *
      (newTab.accommodations[actualRoom]?.rooms?.value || 1) *
      element.ariValue.totalRate;
  }

  return total;
};

export const functionGetAccommodationsByPropertyAri = (
  actualTab: any,
  tabs: any,
  dataPropertyAri: any,
  validateInventory: any,
  actualRoom: number
) => {
  if (!actualTab || !tabs) {
    return [];
  }

  const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);

  if (
    indexTab > -1 &&
    tabs[indexTab]?.establishment &&
    dataPropertyAri[tabs[indexTab]?.establishment?.value]
  ) {
    const dataAri: {
      occupants: any;
      inventories: any[];
      accommodations: any;
      mealplans: any;
      arivalues: any;
      conditions: any;
      services: any;
    } = dataPropertyAri[tabs[indexTab]?.establishment?.value];
    let dataInventories: any = [];
    let dataInventoriesNotApplyCondition: any = [];

    for (const [key, value] of Object.entries(dataAri.inventories)) {
      if (value?.condition === tabs[indexTab]?.condition.value) {
        if (dataAri?.accommodations?.[value.accommodation]?.name) {
          const nameMealPlan = dataAri.mealplans[value.mealplan].name;

          const nameCondition = dataAri.conditions[value.condition].name;
          const nameAccommodation = dataAri?.accommodations?.[value.accommodation]?.name;
          const allMealplans = Object.values({ ...dataAri.mealplans }).map((mealplan: any) => {
            const joinAccomodations: any = `${value.ticker}`;

            const { obligatoryExtrasValue, dataExtrasObligatory } = calcObligatoryExtraValue({
              dataAri,
              joinAccomodations,
              tabs,
              indexTab,
              actualRoom,
            });

            const newPrices = validateInventory(
              dataAri?.arivalues?.[joinAccomodations],
              value.ticker,
              tabs[indexTab].accommodations
            );

            const occupations = calculateMealPlanOccupations(
              dataAri?.inventories?.[joinAccomodations]?.configuration
            );

            return {
              value: mealplan.ticker,
              label: mealplan.name,
              prices: { ...newPrices, obligatoryExtrasValue },
              occupations,
              extraPrice: 0,
              dataExtrasObligatory,
            };
          });

          const indexInventory = dataInventories.findIndex(
            (inventory: any) => inventory.accommodation === value.accommodation
          );
          const mealPlanIndexToAdd = allMealplans.findIndex(
            (mealPlan: any) => mealPlan.value === value.mealplan
          );

          if (indexInventory > -1) {
            let newInventory = dataInventories[indexInventory];
            newInventory.mealplans.push({
              ...allMealplans[mealPlanIndexToAdd],
              services: value.services,
            });
            newInventory.services = value.services;
          } else {
            let rooms = { value: 1, label: "1 Habitación" };
            tabs[indexTab].accommodations.forEach((accommodation: any) => {
              if (accommodation.ticker === value.ticker) {
                rooms = accommodation.rooms;
              }
            });

            dataInventories.push({
              ...value,
              rooms,
              nameAccommodation,
              nameMealPlan,
              nameCondition,
              mealPlan: { ...allMealplans[mealPlanIndexToAdd] },
              mealplans: [{ ...allMealplans[mealPlanIndexToAdd], services: value.services }],
            });
          }
        } else {
          dataInventoriesNotApplyCondition[key] = {
            value,
          };
        }
      } else {
        dataInventoriesNotApplyCondition[key] = {
          value,
        };
      }
    }

    let availableData: any[] = [];
    let restrictedData: any[] = [];
    let soldOutData: any[] = [];
    dataInventories.forEach((inventory: any) => {
      if (inventory.mealPlan.prices.lastStatus.code === "AVAILABLE") {
        availableData.push(inventory);
      } else if (inventory.mealPlan.prices.restricted) {
        restrictedData.push(inventory);
      } else if (inventory.mealPlan.prices.availability <= 0) {
        soldOutData.push(inventory);
      }
    });
    return [...availableData, ...restrictedData, ...soldOutData];
  }
};

const transformExtra = ({ extra, stayDate = [], numberPerson = 2, numberRoom = 2 }: any) => {
  let showedQuantity = 0;
  let quantity = 0;
  const dateQuantity = stayDate.reduce((acc: any, value: any) => {
    if (
      (extra.type === "UNIT" && extra.dateSelectionType === "SPECIFIC") ||
      (extra.type === "PERSON" && extra.dateSelectionType === "SPECIFIC") ||
      (extra.type === "ROOM" && extra.dateSelectionType === "SPECIFIC")
    ) {
      const e = extra.list.find((itemList: any) => {
        return format(new Date(itemList.day), "yyyy-MM-dd") ===
          format(new Date(value), "yyyy-MM-dd")
          ? itemList
          : null;
      });
      acc[value] = e?.value?.value || e?.value || 0;
      showedQuantity = e?.value?.value || e?.value || 0;
    } else if (extra.type === "UNIT" && extra.dateSelectionType === "NONE") {
      acc[value] = extra.list[0].value.value /** numberRoom*/;
      showedQuantity = extra.list[0].value.value;
    } else if (extra.type === "UNIT" && extra.dateSelectionType === "ALL") {
      acc[value] = extra.list[0].value.value;
      showedQuantity += extra.list[0].value.value;
    } else if (extra.type === "PERSON" && extra.dateSelectionType === "NONE") {
      acc[value] = 1;
      quantity = 0;
      showedQuantity = 0;
    } else if (extra.type === "PERSON" && extra.dateSelectionType === "ALL") {
      acc[value] = 1;
      quantity = 0;
      showedQuantity = 0;
    } else if (extra.type === "ROOM" && extra.dateSelectionType === "ALL") {
      acc[value] = 1;
      quantity = 0;
      showedQuantity += 1;
    } else if (extra.list.length) {
      const index = extra.list.findIndex(
        (item: any) => format(new Date(item.day), "MM-dd") === format(new Date(value), "MM-dd")
      );
      if (index > -1) {
        showedQuantity += 1;
        if (extra.list[index].value.value) {
          acc[value] = extra.list[index].value.value;
        } else {
          acc[value] = extra.list[index].value;
        }
      }
    } else {
      acc[value] = 1;
      quantity = 1;
      showedQuantity = 1;
    }
    return acc;
  }, {});

  return {
    dateQuantity,
    quantity,
    showedQuantity,
  };
};

export const createSharedBooking = async ({
  tabs,
  actualTab,
  prefixURL,
  engineApiEndpoint,
}: any) => {
  const indexTab = tabs.findIndex((tab: any) => tab.id === actualTab);
  const tab = tabs[indexTab];

  const promoCodes: any = [];
  if (tab.promoCode) {
    promoCodes.push(tab.promoCode);
  } else {
    promoCodes.push(null);
  }

  const cart = tab?.accommodations?.map(
    ({ rooms, extraSelected = [], accommodation, configuration, mealplan, condition }: any) => {
      const services = extraSelected.reduce((acc: any, extra: any) => {
        const startReservation = new Date(tabs[indexTab].checkIn);
        const endReservation = new Date(tabs[indexTab].checkOut);
        const diffDates = differenceInDays(endReservation, startReservation);

        const stayDate: string[] = [];
        for (let index = 0; index < diffDates; index++) {
          stayDate.push(format(add(startReservation, { days: index }), "y-MM-dd"));
        }

        if (extra.obligatory) {
          acc[extra.ticker] = transformExtra({ extra, stayDate });
        } else if (
          extra.open ||
          (extra.type === "UNIT" &&
            extra.dateSelectionType === "NONE" &&
            extra.list?.[0]?.value?.value) ||
          (extra.type === "UNIT" &&
            extra.dateSelectionType === "ALL" &&
            extra.list?.[0]?.value?.value)
        ) {
          acc[extra.ticker] = transformExtra({ extra, stayDate, numberRoom: rooms?.value });
        }
        return acc;
      }, {});

      return {
        id: uuidv4(),
        propertyTicker: tab.establishment.value,
        inventory: `${accommodation}_${configuration}_${mealplan}_${condition}`,
        start: new Date(tab.checkIn).toISOString(),
        end: new Date(tab.checkOut).toISOString(),
        guestAges: null,
        numberOfUnits: rooms?.value,
        services,
      };
    }
  );

  const body = JSON.stringify({
    cart,
    locale: "es",
    promoCodes,
    urlParams: { affiliate: "quotation" },
  });

  const { headers } = await axios.post(`${engineApiEndpoint}/api/bookings/create`, body, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  const keyLocation = headers?.["location"]?.split("/")?.pop();
  const engineVersion = tab?.configurations?.engineVersion;
  const sharedURL =
    engineVersion === ENGINE_VERSION["21"]
      ? `${prefixURL}/hotel/${tab.establishment.value}/checkout?session=${keyLocation}&isSharedBooking=1&setconversion=${tab.currency.value}`
      : `${prefixURL}/hotel/${tab.establishment.value}/checkout?session=${keyLocation}&isSharedBooking=1&setconversion=${tab.currency.value}`;
  window.open(sharedURL, "_blank");
};

export function calculateDeposit({
  condition,
  dataPropertyAri,
  tabs,
  tab,
  totalRate,
  indexTab,
  indexRoom,
}: any) {
  if (!condition || !totalRate) {
    return 0;
  }
  const { payFirstNight, earlyCharge, minimumCharge } = condition;
  const firstNightCost =
    dataPropertyAri[tabs[indexTab]?.establishment?.value]?.arivalues[
      tab?.accommodations?.[indexRoom]?.ticker
    ]?.firstNightCost;
  const quantity = tab?.accommodations?.[indexRoom]?.rooms?.value;

  // Calculate the first night cost if the condition has this configuration or return zero
  const firstNightPrice: number = payFirstNight ? firstNightCost * quantity : 0;

  let minimumChargePrice = 0;
  // Check if minimum charge is configured
  if (minimumCharge > 0) {
    // If the minimum charge is bigger than the reservation total amount take the latter value
    minimumChargePrice = Math.min(minimumCharge, totalRate);
  }

  // Calculate the early charge price if the condition has this configuration or return zero
  let earlyChargePrice: number = earlyCharge ? totalRate * (earlyCharge / 100) : 0;
  // Take the max value between the minCharge price and the calculated early charge price
  earlyChargePrice = Math.max(earlyChargePrice, minimumChargePrice);

  // We always charge the largest calculated deposit
  return Math.max(firstNightPrice, earlyChargePrice, minimumChargePrice);
}
